// Moves keyboard focus and view to the first invalid field after a failed submit.
export default function focusFirstInvalid(root = document) {
  const target = root.querySelector('.is-invalid, [aria-invalid="true"]')
    || (root.querySelector('.b-form-invalid-custom span') || {}).parentElement
  if (!target) return false
  target.scrollIntoView({ behavior: 'smooth', block: 'center' })
  const control = target.matches('input, textarea, select, button') ? target : target.querySelector('input, textarea, select')
  if (control) control.focus({ preventScroll: true })
  return true
}
